module.exports = __webpack_public_path__ + "img/摄图网_501111552_banner_幼儿园老师指导画画（非企业商用）.abab6e37.png";